import { useDispatch, useSelector } from 'react-redux'

import Button from '@/components/form/Button'
import { Translation } from '@/components/i18n/Translation'
import { closePopup } from '@/ducks/popupReducer'
import { removeProduct } from '@/ducks/shopOrderReducer'
import { getProductFromId } from '@/ducks/shopProductsReducer'

const ProductRemovalDialog = ({ productId }: any) => {
  const { name } = useSelector(state => getProductFromId(state, productId)) || {}
  const dispatch = useDispatch()
  const onConfirm = () => {
    dispatch(removeProduct(productId))
    dispatch(closePopup())
  }

  return (
    <div>
      <h2>
        <Translation id="Remove product from order" />
      </h2>

      <p>
        <Translation
          id="Are your sure you wish to remove {name} from your order?"
          name={<i>{name}</i>}
        />
      </p>

      <div className="button-spread">
        <Button onClick={() => dispatch(closePopup())}>
          <Translation id="No, cancel" />
        </Button>

        <Button onClick={onConfirm}>
          <Translation id="Yes, remove product" />
        </Button>
      </div>
    </div>
  )
}

export default ProductRemovalDialog
